function closeMobile() {
  const menu = document.getElementById('mobileMenu');
  if (menu) menu.classList.remove('open');
}

document.addEventListener('DOMContentLoaded', () => {
  const reveals = document.querySelectorAll('.reveal');

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08 }
    );

    reveals.forEach((reveal) => io.observe(reveal));
  } else {
    reveals.forEach((reveal) => reveal.classList.add('visible'));
  }

  document.querySelectorAll('.nav-logo img,.footer-brand img').forEach((img) => {
    img.addEventListener('error', () => {
      img.style.display = 'none';
      const span = img.nextElementSibling;
      if (span) span.style.display = 'block';
    });
  });
});

function toggleFaq(btn) {
  const item = btn.parentElement;
  const wasOpen = item.classList.contains('open');
  document.querySelectorAll('.faq-item').forEach((faqItem) => faqItem.classList.remove('open'));
  if (!wasOpen) item.classList.add('open');
}

function filterFaq(cat, btn) {
  document.querySelectorAll('.faq-cat-btn').forEach((catBtn) => catBtn.classList.remove('active'));
  btn.classList.add('active');
  document.querySelectorAll('.faq-item').forEach((item) => {
    item.classList.remove('open');
    item.style.display = cat === 'all' || item.dataset.cat === cat ? 'block' : 'none';
  });
}

function switchTab(id, btn) {
  document.querySelectorAll('.tab-btn').forEach((tabBtn) => tabBtn.classList.remove('active'));
  document.querySelectorAll('.tab-content').forEach((content) => content.classList.remove('active'));
  btn.classList.add('active');
  const tab = document.getElementById(`tab-${id}`);
  if (tab) tab.classList.add('active');
}

function adjustQty(delta) {
  const input = document.getElementById('qty');
  if (!input) return;
  const value = parseInt(input.value, 10) + delta;
  if (value >= 1 && value <= 20) input.value = value;
}

function setMain(thumb) {
  const mainImg = document.getElementById('mainImg');
  if (!mainImg) return;
  mainImg.src = thumb.src;
  document.querySelectorAll('.thumb').forEach((item) => item.classList.remove('active'));
  thumb.classList.add('active');
}

function addToCart() {
  const btn = document.querySelector('.btn-add-to-cart');
  if (!btn) return;
  btn.textContent = '✓ Añadido al Carrito';
  btn.style.background = 'var(--gold)';
  btn.style.color = 'var(--black)';
  setTimeout(() => {
    btn.textContent = '✦ Añadir al Carrito';
    btn.style.background = 'var(--black)';
    btn.style.color = 'var(--gold-light)';
  }, 2800);
}

function handleFormSubmit() {
  alert('Gracias por tu mensaje. Responderemos en un plazo de 24 horas.\nPara consultas urgentes, contáctanos por WhatsApp: +34 615 430 785');
}
